<template>
  <div class="login-content-obox">
    <div class="login-content-obox-1">
      <div class="login-content-obox-1-otop">
        <p class="op1">验证码登录</p>
        <p class="op2" @click="switchlogin">密码登录</p>
      </div>
      <div class="login-content-obox-1-obottom">
        <Form class="oF">
          <FormItem class="oF-1">
            <Input class="oI" :value.sync="formItem.input" placeholder="手机号" />
            <Input class="oI" :value.sync="formItem.input" placeholder="短信验证码" />
            <span class="lcode">获取验证码</span>
          </FormItem>
          <div class="oF-2">
              <Checkbox class="osave-btn">&nbsp;&nbsp;&nbsp;记住我</Checkbox>
              <p class="oF-2-text">忘记密码</p>
          </div>
          <Button type="primary" size="large">登录</Button>
          <Button class="owx-btn" @click="wxlogin" size="large">
            <div style="width:22px;height:22px;padding:3px 5px;background-color:#3eb135;border-radius:50%;display:inline-block"><img style="width:13px;height:11px;" src="../img/weixin.png" alt="微信"></div>
            微信扫码登录
          </Button>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formItem: {
        input: '',
        select: '',
        radio: 'male',
        checkbox: [],
        switch: true,
        date: '',
        time: '',
        slider: [20, 50],
        textarea: ''
      }
    }
  },
  methods: {
    switchlogin () {
      this.$router.push('alogin')
    },
    wxlogin () {
      this.$router.push('clogin')
    }
  }
}
</script>

<style lang="scss" scoped>
.login-content-obox {
  width: 384px;
  height: 425px;
  position: absolute;
  right: 19.5%;
  bottom: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
  &-1 {
    width: 361px;
    height: 351px;
    background-color: #fff;
    box-shadow: 0px 0px 10px 0px rgba(139, 140, 140, 0.3);
    border-radius: 2px;
    position: relative;
    &-otop {
      width: 263px;
      height: 40px;
      position: absolute;
      top: 9px;
      left: 43px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .op1 {
        width: 91px;
        height: 17px; 
        font-size: 18px; 
        line-height: 16px;
        color: #1890ff;
        cursor: pointer;
        font-weight: bold;
      }
      .op2 {
        width: 72px;
        height: 19px; 
        font-size: 18px; 
        line-height: 16px;
        color: #808080;
        cursor: pointer;
        font-weight: bold;
      }
    }
    &-obottom {
      width: 300px;
      height: 350px;
      position: absolute;
      top: 49px;
      left: 29px;
    }
  }
}
.oF {
  display: flex;
  flex-direction: column;
  width: 300px;
  height: 350px;
  position: relative;
  &-1 {
    margin-top: 15px;
    margin-bottom: 0;
    .oI{
      margin-top: 19px;
    }
  }
  .oF-2 {
    width: 100%;
    height: 15px;
    line-height: 15px;
    display: flex;
    justify-content: space-between;
    margin: 14px 0 23px 0;
    .oF-2-text {
      width: 48px;
      height: 13px;
      font-size: 12px;
      color: #333;
      cursor: pointer;
    }
  }
  .owx-btn {
    margin-top: 20px;
  }
  .lcode {
    width: 72px;
    height: 18px;
    font-size: 14px;
    color: #1890ff;
    line-height: 18px;
    position: absolute;
    top: 77px;
    right: 8px;
    cursor: pointer;
  }
}
</style>